var map = {
	"./dashboard-content.png": 4078,
	"./no-collections.png": 6253,
	"./partners-docs/governance_01.png": 426,
	"./partners-docs/governance_02.png": 4657,
	"./partners-docs/governance_03.png": 3528,
	"./partners-docs/governance_04.png": 2519,
	"./partners-docs/governance_05.png": 6942,
	"./partners-docs/governance_06.png": 7301,
	"./partners-docs/support2.png": 795,
	"./partners/funbio.png": 3757,
	"./partners/fva.png": 869,
	"./partners/idesam.png": 8151,
	"./partners/idsm.png": 1845,
	"./partners/idsm2.png": 7763,
	"./partners/ieb.png": 5700,
	"./partners/ift.png": 467,
	"./partners/imaflora.png": 2145,
	"./partners/imazon.png": 5250,
	"./partners/ipam.png": 947,
	"./partners/ipe.png": 6315,
	"./partners/isa.png": 7993,
	"./partners/kaninde.png": 7202,
	"./partners/tnc.png": 1629,
	"./partners/wcs.png": 8817,
	"./partners/woodwell.png": 965,
	"./partners/wwf.png": 2624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5786;